import type { SVGProps } from 'react';
const SvgWbShade = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#wb_shade_svg__a)">
      <path
        fill="currentColor"
        d="M14 12v2.5l5.5 5.5H22l-8-8Zm0 8h3l-3-3v3ZM8 4l-6 6h2v10h8V10h2L8 4Zm1 10H7v-4h2v4Z"
      />
    </g>
    <defs>
      <clipPath id="wb_shade_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWbShade;
